module.exports = __webpack_public_path__ + "static/media/Puffy Hearts 300g.e786a70f.jpg";